import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AgentBypassKycResult,
  KYC_SKIP_REASONS,
  KycService,
  KycSkipReason,
} from 'src/app/core/services/kyc.service';
import { UserService } from 'src/app/core/services/user.service';

export interface AgentSkipKycDialogData {
  userId: string;
  actionId?: string;
  defaultReason?: KycSkipReason;
}

export interface AgentSkipKycDialogResult {
  saved: boolean;
  reason?: KycSkipReason;
  bypass?: AgentBypassKycResult;
}

type Phase = 'SELECT' | 'POST_SAVE';

@Component({
  selector: 'app-agent-skip-kyc-modal',
  templateUrl: './agent-skip-kyc-modal.component.html',
  styleUrls: ['./agent-skip-kyc-modal.component.scss'],
})
export class AgentSkipKycModalComponent {
  readonly reasons: KycSkipReason[] = [...KYC_SKIP_REASONS];
  selectedReason: KycSkipReason | null = null;
  phase: Phase = 'SELECT';
  saving = false;
  error: string | null = null;
  result: AgentBypassKycResult | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AgentSkipKycDialogData,
    public dialogRef: MatDialogRef<AgentSkipKycModalComponent, AgentSkipKycDialogResult>,
    private kycService: KycService,
    private userService: UserService,
  ) {
    this.selectedReason = data.defaultReason ?? null;
  }

  async onSave(): Promise<void> {
    if (!this.selectedReason || this.saving) return;

    this.saving = true;
    this.error = null;
    try {
      const bypass = await this.kycService.agentBypassKyc(
        this.data.userId,
        this.selectedReason,
        this.data.actionId,
      );
      this.userService.clearUserCache();
      this.result = bypass;
      this.phase = 'POST_SAVE';
    } catch (err: any) {
      console.error('[KYC] Agent skip KYC failed:', err);
      this.error = err?.error?.message || err?.message || 'unknown_error';
    } finally {
      this.saving = false;
    }
  }

  onCancel(): void {
    this.dialogRef.close({ saved: false });
  }

  onAcknowledgePostSave(): void {
    this.dialogRef.close({
      saved: true,
      reason: this.selectedReason ?? undefined,
      bypass: this.result ?? undefined,
    });
  }
}
